var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.isShowLanding)?_c('homepage'):_vm._e(),(_vm.isLoggedIn)?_c('dashboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }